import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { TitleService } from '@core/services/title.service';

import { File } from '@core/objects/file';
import { Version } from '@core/objects/version';

import { VersionFeedback } from '@core/models/version-feedback';

@Component({
    selector: 'plugin-share-feedback-feedback-review',
    templateUrl: './feedback-review.component.html',
    styleUrls: ['./feedback-review.component.scss']
})
export class PluginShareFeedbackFeedbackReviewComponent implements OnInit, OnChanges {
    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_FOUND = 3;

    @Input() feedback: VersionFeedback;

    public version: Version;
    public files: Array<File> = [];
    public messages: Array<any> = [];
    public prefixUrl: string = '';
    public prefixNotesUrl: string = '';

    public selectedFile: File = null;
    public status: number = this.STATUS_LOADING;
    // public view: number = this.VIEW_APPROVAL_NONE;
// - Review versions and files using the thumbnail
// - You can leave a message and attach files to the requestor
// - When you are ready, leave your approval or rejection with a good reason"

    public showMessageAdd: boolean = false; // message form

    constructor( 
        private title: TitleService,) {}

    ngOnInit() {
        this.init();

    }

    ngOnChanges(changes: SimpleChanges){
        if(changes.feedback){
            console.debug(" feedback SimpleChanges");
            this.init();
        }
    }

    protected init() {
        this.status = this.STATUS_DONE;
        this.version = null;
        this.version = this.feedback.version;
        this.prefixUrl = '/p/feedback';
        this.prefixNotesUrl = '/p/feedback/versions/'+this.version.id;
        this.title.set("Feedback on version " + this.feedback.version.version);
        this.selectedFile = null; // maybe not used
        
    }
    
}
